import React, { useState, useEffect } from "react";
import {Box, IconButton, Slider, Typography} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {observer} from "mobx-react-lite";
import {SequenceStateStore} from "../store/SequenceStateStore";
import {SequenceTimelineStore} from "../store/SequenceTimelineStore";
import {SequenceCompositionService} from "../services/SequenceCompositionService";
import { secondsToTimecode } from "../../librettoEditor/utils/secondsToTimecode";
import Button from "../../librettoEditor/components/Button/Button";
import {PlayIcon} from "../../librettoEditor/assets/icons/PlayIcon";
import {PauseIcon} from "../../librettoEditor/assets/icons/PauseIcon";
import { autorun } from "mobx";
import {ScissorsIcon} from "../../librettoEditor/assets/icons/ScissorsIcon";
import {SequenceApplicationStore} from "../store/SequenceApplicationStore";

interface SequenceControlsProps {
}

const SequenceControls: React.FC<SequenceControlsProps> = observer(() => {
    const [isPlaying, setIsPlaying] = useState(SequenceStateStore.isPlaying);
    const [displayTime, setDisplayTime] = useState(secondsToTimecode(SequenceStateStore.currentTime, true, true));

    const [selectedClipId, setSelectedClipId] = useState<string | null>(null);

    useEffect(() => {
        const dispose = autorun(() => {
            setIsPlaying(SequenceStateStore.isPlaying);
            setDisplayTime(secondsToTimecode(SequenceStateStore.currentTime, true, true));
            setSelectedClipId(SequenceApplicationStore.selectedClipId);
            // setCanUndo(CompositionStore.canUndo);
            // setCanRedo(CompositionStore.canRedo);
        });

        return () => dispose();
    }, []);

    const handlePlay = () => SequenceCompositionService.play();
    const handlePause = () => SequenceCompositionService.pause();
    const handleTrash = () => {}
    const handleSplit = () => {SequenceCompositionService.splitClip()}
    const decrementZoom = () => SequenceTimelineStore.setZoom(SequenceTimelineStore.zoom - 0.1);
    const incrementZoom = () => SequenceTimelineStore.setZoom(SequenceTimelineStore.zoom + 0.1);
    const handleUndo = async () => {
        // await RendleyService.getEngine().getUndoManager().undo();
    };
    const handleRedo = async () => {
        // await RendleyService.getEngine().getUndoManager().redo();
    };

    const handleToggleRange = () => {
        // ApplicationStore.setRangeToolEnabled(!ApplicationStore.rangeToolEnabled);
    };

    const isClipSelected = selectedClipId != null;
    const isSplitEnabled = isClipSelected;
    const isRangeToolEnabled = isClipSelected;
    const isTrashEnabled = isClipSelected;

    return (
        <Box>
            <div className="controls">
                <div className="controls__section">
                    {/*<Button disabled={!isTrashEnabled} onClick={handleTrash}>*/}
                    {/*  <TrashIcon />*/}
                    {/*</Button>*/}
                </div>

                <div className="controls__section">
                    {/*<Button onClick={handleStop}>*/}
                    {/*    <div className="controls__section--stop-btn"></div>*/}
                    {/*</Button>*/}

                    {isPlaying ? (
                        <Button onClick={handlePause}>
                            <PauseIcon/>
                        </Button>
                    ) : (
                        <Button onClick={handlePlay}>
                            <PlayIcon/>
                        </Button>
                    )}

                    {/*<Button onClick={() => {*/}
                    {/*    CompositionService.previousFrame()*/}
                    {/*}}>*/}
                    {/*    <BiSolidLeftArrow/>*/}
                    {/*</Button>*/}
                    {/*<Button onClick={() => {CompositionService.nextFrame()}}>*/}
                    {/*    <BiSolidRightArrow/>*/}
                    {/*</Button>*/}
                    <span className="controls__playback__time">{displayTime}</span>
                </div>

                <div className="controls__section">

                    {/*<Button disabled={!isSplitEnabled} onClick={handleSplit} title={"Blade"}>*/}
                    {/*    <ScissorsIcon/>*/}
                    {/*</Button>*/}

                    {/*<Button disabled={!isRangeToolEnabled} onMouseDown={handleToggleRange} variant={rangeEnabled ? "primary" : "ghost"} title={"Range"}>*/}
                    {/*    <RangeIcon/>*/}
                    {/*</Button>*/}

                </div>
            </div>
        </Box>
    );
});

export default SequenceControls;


